import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { routingConstants } from "@/Constants/routingConstants";

// logout -->  Is the function that triggers the logout process.
// isLoggingOut --> Is the state that tracks whether the logout is currently happening or not.

const AuthLogout = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const logout = () => {
    if (!isLoggingOut) {
      setIsLoggingOut(true);
      navigate(routingConstants.logout);
    }
  };
  return { logout, isLoggingOut };
};

export default AuthLogout;
